import { parse } from 'mathjs';
import { getField, updateField } from 'vuex-map-fields';

class Modal {
    constructor({top, left, width, height, shiftX, shiftY}) {
        this.top= top
        this.left= left;
        this.width= width;
        this.height = height;
        this.shiftX = shiftX;
        this.shiftY = shiftY;
    }
}

const models = {
    Modal
};

var defaultThirdPartyModal = new Modal({width: '80%', height: '80%', shiftX: 0.5, shiftY: 0.5});

const KEYS_COOKIES = {
    third_party: {
        top: "third_party_top",
        left: "third_party_left",
        width: "third_party_width",
        height: "third_party_height",
        shift_x: 'third_party_shift_x',
        shift_y: 'third_party_shift_y'
    },
}

const state = () => ({
    thirdPartyModal: defaultThirdPartyModal,
});


const getters = {
    getField,
};

export const SET_THIRD_PARTY_VALUES = 'SET_THIRD_PARTY_VALUES';

const mutations = {
    updateField,
    [SET_THIRD_PARTY_VALUES](state, { top, left, width, height, shiftX, shiftY}) { 
        state.thirdPartyModal.top = top;
        state.thirdPartyModal.left = left;        
        state.thirdPartyModal.width = (parseInt(width) >= 300) ? width : '80%';
        state.thirdPartyModal.height =  (parseInt(height) >= 300) ? height : '80%';
        if (!isNaN(shiftX)) {
            state.thirdPartyModal.shiftX = parseFloat(shiftX);
        }
        if (!isNaN(shiftY)) {
            state.thirdPartyModal.shiftY = parseFloat(shiftY);
        }
    }
};

function getValueCookie(key)  {
    var cookies = document.cookie.split(';');
    var value = undefined;
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].split('=')
        var keyCookie = cookie[0].replace(/^\s+/g, '');
        if (keyCookie == key) {
            value = cookie[1];
            break;
        }
    }
    return value;
}

function setValueCookie(key, value) {
    document.cookie = key + '=' + value;
}

const initialThirdPartyValuesModal = ({ state, commit }) => {
    var top = getValueCookie(KEYS_COOKIES.third_party.top);
    var left = getValueCookie(KEYS_COOKIES.third_party.left);
    var width = getValueCookie(KEYS_COOKIES.third_party.width);
    var height = getValueCookie(KEYS_COOKIES.third_party.height);
    var shiftX = getValueCookie(KEYS_COOKIES.third_party.shift_x);
    var shiftY = getValueCookie(KEYS_COOKIES.third_party.shift_y);
    var values = {
        width: '80%',
        height: '80%',
        shiftX: 0.5,
        shiftY: 0.5
    }
    if (top) {
        values['top'] = top;
    } 
    if (left) {
        values['left'] = left;
    }
    if (width) {
        values['width'] = width;
    }
    if (height) {
        values['height'] = height;
    }
    if (shiftX && shiftX != 'NaN') {
        const parsedShiftX = parseFloat(shiftX);
        if (!isNaN(parsedShiftX) && parsedShiftX >= 0 && parsedShiftX <= 1) {
            values['shiftX'] = parsedShiftX;
        }
    }
    if (shiftY && shiftY != 'NaN') {
        const parsedShiftY = parseFloat(shiftY);
        if (!isNaN(parsedShiftY) && parsedShiftY >= 0 && parsedShiftY <= 1) {
            values['shiftY'] = parsedShiftY;
        }
    }
    commit(SET_THIRD_PARTY_VALUES, values);
}

const setThirdPartyValues = ({ state, commit }) => {
    var modal = document.querySelector('div[data-modal]');
    if (modal) {
        var container = modal.nextElementSibling;
        var top = container.style.top;
        var left = container.style.left;
        var width = container.style.width;
        var height = container.style.height;
        var shiftX = ((parseInt(left) + parseInt(width)) / 2) / (modal.clientWidth - parseInt(width));
        shiftX = Math.round(shiftX*10)/10
        if (isNaN(shiftX) || !isFinite(shiftX) || shiftX < 0 || shiftX > 1) {
            shiftX = 0.5;
        }
        var shiftY = Math.round((parseInt(top) / modal.clientHeight)*10)/10;
        if (isNaN(shiftY) || !isFinite(shiftY) || shiftY < 0 || shiftY > 1) {
            shiftY = 0.5;
        }
        setValueCookie(KEYS_COOKIES.third_party.top, top);
        setValueCookie(KEYS_COOKIES.third_party.left, left);
        setValueCookie(KEYS_COOKIES.third_party.width, width);
        setValueCookie(KEYS_COOKIES.third_party.height, height);
        setValueCookie(KEYS_COOKIES.third_party.shift_x, shiftX);
        setValueCookie(KEYS_COOKIES.third_party.shift_y, shiftY);
        commit(SET_THIRD_PARTY_VALUES, { top, left, width, height, shiftX, shiftY });
        
    }
}

const setThirdPartyPosition = ({ state, commit }) => {
    var modal = document.querySelector('div[data-modal]');
    if (modal) {
        var container = modal.nextElementSibling;
        if (state.thirdPartyModal.top) {
            container.style.top = state.thirdPartyModal.top;
        }
        if (state.thirdPartyModal.left) {
            container.style.left = state.thirdPartyModal.left;
        }
    }
    
}

const actions = {
    initialThirdPartyValuesModal,
    setThirdPartyValues,
    setThirdPartyPosition
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}